module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Shorts.05b24b6a.svg";